(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const contactFormEmbed = document.querySelector('.c-block.contact shopify-forms-embed');      
      if (contactFormEmbed && contactFormEmbed.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          form * {
            font-family: Roboto, sans-serif !important;
          }

          section {
            max-width: 100% !important;
            overflow: visible !important;
          }

          form label,
          form ._selectContainer_12thd_6 p,
          form .dropdownContainer_12thd_63 * {
            font-size: clamp(14px, 1em, 1em) !important;
            font-weight: 400 !important;
            line-height: 120% !important;
            top: 1em !important;
            left: 1em !important;
            transform: none !important;
            pointer-events: none !important;
            color: var(--color--black) !important;
            transition: all .3s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
          }

          form ._formFieldContainer_1mxsl_5:focus-within label,
          form ._formFieldContainer_1mxsl_5 label._inputFilled_ck6wz_74 {
            transform: none !important;
            opacity: 0 !important;
          }

          form ._selectContainer_12thd_6 p {
            position: absolute;
            z-index: 2;
            padding: 0 !important;
          }

          form ._selectContainer_12thd_6:has(._selectToggleText_12thd_25.has-value) p {
            opacity: 0 !important;
          }

          form input._formInputField_nag3b_7,
          form textarea._textArea_17mgw_1,
          form button._selectToggle_12thd_25 {
            border: 1px solid var(--color--light-grey);
            background-color: var(--color--white);
            border-radius: .25em;
            align-items: center;
            height: auto;
            padding: 1em;
            font-size: clamp(14px, 1em, 1em);
            font-weight: 400;
            line-height: 120%;
            display: flex;
            color: var(--color--black);
            max-height: none;
            box-shadow: none !important;
          }

          form input._formInputField_nag3b_7:focus-visible,
          form textarea._textArea_17mgw_1:focus-visible,
          form button._selectToggle_12thd_25:focus-visible {
            border: 1px solid var(--color--light-grey) !important;
            outline: none !important;
            box-shadow: none !important;
          }

          form textarea {
            min-height: 12em;
          }
          
          form button._formSubmitButton_cit2d_96 {
            border: 2px solid var(--color--black);
            background-color: var(--color--black);
            color: var(--color--white);
            text-align: center;
            border-radius: .25em;
            padding: .875em 1.75em;
            min-width: 12em;
            text-decoration: none;
            transition: border-color .6s cubic-bezier(0.165, 0.84, 0.44, 1), color .6s cubic-bezier(0.165, 0.84, 0.44, 1), background-color .6s cubic-bezier(0.165, 0.84, 0.44, 1);
            display: inline-block;
            position: relative;
            letter-spacing: .02em;
            text-transform: uppercase;
            font-size: clamp(16px, 1.125em, 1.125em);
            line-height: 120%;
          }

          form button._formSubmitButton_cit2d_96:focus-visible, 
          form button._formSubmitButton_cit2d_96:hover {
            border: 2px solid var(--color--grey);
            background-color: var(--color--grey);
            color: var(--color--white);
            filter: none;
          }
        `;
        contactFormEmbed.shadowRoot.appendChild(style);


        const script = document.createElement('script');
        script.textContent = `
          const contactFormEmbed = document.querySelector('.c-block.contact shopify-forms-embed');
          const selectText = contactFormEmbed.shadowRoot.querySelector('._selectToggleText_12thd_25');

          if (selectText) {
            // Detect when text is injected into selectText
            const observer = new MutationObserver(function(mutationsList) {
              for (const mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                  selectText.classList.add('has-value');
                }
              }
            });
            observer.observe(selectText, { childList: true, characterData: true, subtree: true });
          }
        `;
        contactFormEmbed.shadowRoot.appendChild(script);
      }
    }, 1000); // Adjust timeout as needed
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function(){
  // --- Setup ---
  var id  = 'krbl-progress-{{ section.id }}';
  var bar = document.getElementById(id);
  if(!bar) return;

  // Ensure the fill exists
  var fill = bar.querySelector('.krbl-progress__fill');
  if(!fill){
    fill = document.createElement('div');
    fill.className = 'krbl-progress__fill';
    bar.appendChild(fill);
  }

  // Move to <body> to avoid clipping/stacking issues
  try{ if(bar.parentNode !== document.body){ document.body.appendChild(bar); } }catch(e){}

  // --- Helpers ---
  function clamp01(x){ return x < 0 ? 0 : x > 1 ? 1 : x; }

  function docRatio(){
    var de = document.documentElement, b = document.body;
    var sh = Math.max(de.scrollHeight, b.scrollHeight);
    var ch = window.innerHeight || de.clientHeight;
    var max = Math.max(1, sh - ch);
    var st  = window.scrollY || de.scrollTop || b.scrollTop || 0;
    return clamp01(st / max);
  }

  function bestScrollableRatio(){
    var best = 0;
    var cands = [
      document.getElementById('MainContent'),
      document.querySelector('main'),
      document.querySelector('.content-for-layout'),
      document.querySelector('.shopify-section'),
      document.querySelector('.page-width')
    ].filter(Boolean);

    // Add any element that looks scrollable
    document.querySelectorAll('body *').forEach(function(el){
      var cs = getComputedStyle(el);
      var oy = cs.overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay')) {
        var max = el.scrollHeight - el.clientHeight;
        if (max > 1) {
          var r = el.scrollTop / max;
          if (r > best) best = r;
        }
      }
    });

    // Check our initial candidates too
    cands.forEach(function(el){
      var max = el.scrollHeight - el.clientHeight;
      if (max > 1) {
        var r = el.scrollTop / max;
        if (r > best) best = r;
      }
    });

    return clamp01(best);
  }

  function rectRatio(){
    var target = document.querySelector('[data-progress-target]')
              || document.querySelector('.article-content')
              || document.querySelector('article')
              || document.body;
    var vh   = window.innerHeight || document.documentElement.clientHeight;
    var rect = target.getBoundingClientRect();
    var progressed = Math.max(0, -rect.top);
    var total = Math.max(1, rect.height - vh);
    return clamp01(progressed / total);
  }

  // --- Animation loop (bulletproof) ---
  var last = -1;
  function tick(){
    var r = Math.max( docRatio(), bestScrollableRatio(), rectRatio() );
    var pct = Math.round(r * 100);

    // Inline width with !important to smash any stylesheet rule
    fill.style.setProperty('width', (r * 100) + '%', 'important');
    bar.setAttribute('aria-valuenow', String(pct));
    if (pct !== last) {
      bar.setAttribute('data-krbl', pct + '%'); // tiny debug marker you can inspect
      last = pct;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Only redirect if we're on the cart page and not in the theme editor
    if (window.__IN_SHOPIFY_EDITOR__ || window.Shopify?.designMode) {
      return;
    }
    
    // Only redirect if we're actually on the cart page template
    if (document.body.classList.contains('template-cart')) {
      window.location.href = '/?cart=open';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pvq-phases-explorer"] && !Shopify.designMode) return;
  try {
    
// Tiny, dependency-free tabs
(() => {
  const root = document.currentScript.closest('.pvq-phases');
  if (!root) return;
  const tabs = root.querySelectorAll('.pvq-tabs__tab');
  const panels = root.querySelectorAll('.pvq-tabs__panel');

  function activate(id) {
    tabs.forEach(t => {
      const on = t.dataset.target === id;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(p => p.classList.toggle('is-active', p.id === id));
  }

  tabs.forEach(btn => btn.addEventListener('click', () => activate(btn.dataset.target)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-cancellations-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const returnsCancellationsFormEmbed = document.querySelector('.c-block.returns-cancellations shopify-forms-embed');      
      if (returnsCancellationsFormEmbed && returnsCancellationsFormEmbed.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          form * {
            font-family: Roboto, sans-serif !important;
          }
                  
          section {
            max-width: 100% !important;
            overflow: visible !important;
          }

          form label,
          form ._selectContainer_12thd_6 p,
          form .dropdownContainer_12thd_63 * {
            font-size: clamp(14px, 1em, 1em) !important;
            font-weight: 400 !important;
            line-height: 120% !important;
            top: 1em !important;
            left: 1em !important;
            transform: none !important;
            pointer-events: none !important;
            color: var(--color--black) !important;
            transition: all .3s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
          }

          form ._formFieldContainer_1mxsl_5:focus-within label,
          form ._formFieldContainer_1mxsl_5 label._inputFilled_ck6wz_74 {
            transform: none !important;
            opacity: 0 !important;
          }

          form ._selectContainer_12thd_6 p {
            position: absolute;
            z-index: 2;
            padding: 0 !important;
          }

          form ._selectContainer_12thd_6:has(._selectToggleText_12thd_25.has-value) p {
            opacity: 0 !important;
          }

          form input._formInputField_nag3b_7,
          form textarea._textArea_17mgw_1,
          form button._selectToggle_12thd_25 {
            border: 1px solid var(--color--light-grey);
            background-color: var(--color--white);
            border-radius: .25em;
            align-items: center;
            height: auto;
            padding: 1em;
            font-size: clamp(14px, 1em, 1em);
            font-weight: 400;
            line-height: 120%;
            display: flex;
            color: var(--color--black);
            max-height: none;
            box-shadow: none !important;
          }

          form input._formInputField_nag3b_7:focus-visible,
          form textarea._textArea_17mgw_1:focus-visible,
          form button._selectToggle_12thd_25:focus-visible {
            border: 1px solid var(--color--light-grey) !important;
            outline: none !important;
            box-shadow: none !important;
          }

          form textarea {
            min-height: 12em;
          }
          
          form button._formSubmitButton_cit2d_96 {
            border: 2px solid var(--color--black);
            background-color: var(--color--black);
            color: var(--color--white);
            text-align: center;
            border-radius: .25em;
            padding: .875em 1.75em;
            min-width: 12em;
            text-decoration: none;
            transition: border-color .6s cubic-bezier(0.165, 0.84, 0.44, 1), color .6s cubic-bezier(0.165, 0.84, 0.44, 1), background-color .6s cubic-bezier(0.165, 0.84, 0.44, 1);
            display: inline-block;
            position: relative;
            letter-spacing: .02em;
            text-transform: uppercase;
            font-size: clamp(16px, 1.125em, 1.125em);
            line-height: 120%;
          }

          form button._formSubmitButton_cit2d_96:focus-visible, 
          form button._formSubmitButton_cit2d_96:hover {
            border: 2px solid var(--color--grey);
            background-color: var(--color--grey);
            color: var(--color--white);
            filter: none;
          }
        `;
        returnsCancellationsFormEmbed.shadowRoot.appendChild(style);


        const script = document.createElement('script');
        script.textContent = `
          const returnsCancellationsFormEmbed = document.querySelector('.c-block.returns-cancellations shopify-forms-embed');
          const selectText = returnsCancellationsFormEmbed.shadowRoot.querySelector('._selectToggleText_12thd_25');

          if (selectText) {
            // Detect when text is injected into selectText
            const observer = new MutationObserver(function(mutationsList) {
              for (const mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                  selectText.classList.add('has-value');
                }
              }
            });
            observer.observe(selectText, { childList: true, characterData: true, subtree: true });
          }
        `;
        returnsCancellationsFormEmbed.shadowRoot.appendChild(script);
      }
    }, 1000); // Adjust timeout as needed
  });

  } catch(e) { console.error(e); }
})();
})();
